






































































import { editFactory } from '@/main/pages';
import { Dilenske } from '@/modules/ciselnik/dilenske';
import { PracovniPozice } from '@/modules/ciselnik/dilenske/pracovniPozice';

import { NAME } from './constants';
import { store } from './store/edit';
import { editMutations } from './store/types';
import Select from '../../components/Select.vue';

export default editFactory(NAME, store).extend({
	components: {
		VozidloSelect: Select,
		PpNrSelect: Dilenske.components.PpNrSelect,
	},
	data() {
		return {
			tabItems: {
				name: { id: 'name', labelKey: 'HlUdaje' },
				opravy: { id: 'opravy', labelKey: 'cmdHistOprav' },
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				ppNr: `${this.storeUri}/${editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER}`,
			};
		},
		vozidloSelectFilter() {
			return {
				VozidloId: this.VozidloId,
			};
		},
		isPpButtonDisabled(): boolean {
			return (!this.PpNr || this.PpNr.length < 2);
		},
		ppServiceNrFilter() : Record<string, any> {
			return {
				// PpNr rozsiruje PpServiceNr kde prvni 4 cisla urcuji PpServiceNr servisni cinost a PpNr druh cinosti
				PpNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
			};
		},
		ppDruhFilter() : Record<string, any> {
			return {
				PpServisNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
			};
		},
		pracovniPoziceFilter() : Record<string, any> {
			return {
				PpNr: this.PpNr,
				Type: PracovniPozice.ppTypes.DEFAULT,
			};
		},
		textPreview() {
			return `<b>${this.LocalizePopisostatni('VOZZAVADAText4ZL')}</b>: ${this.Text || ''}<br />`
				+ `<b>${this.LocalizePopisostatni('VOZZAVADAText42DD')}</b>: ${this.TextPfx || ''} ${this.Text || ''} ${this.TextSfx || ''}.`;
		},
	},
	watch: {
		async VozzavtypPzn(value: any) {
			if (value && this.isCreateMode) {
				await this.default({ VozidloId: this.VozidloId, VozzavtypPzn: value });
			}
		},
	},
});
